import request from '@/utils/request';

const baseURLAdmin = process.env.VUE_APP_ADMIN;

// LM损失定责-分页查询
export const lmLossResponsibilityPage = (data) => {
  return request({
    url: '/lmLossResponsibility/page',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// LM损失定责-统计查询
export const lmLossResponsibilityStatistics = (data) => {
  return request({
    url: '/lmLossResponsibility/statisticsQuery',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// LM损失定责-列表导出
export const lmLossResponsibilityExport = (data) => {
  return request({
    url: '/lmLossResponsibility/export',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// LM损失定责-批量导入
export const lmLossResponsibilityImport = (data) => {
  return request({
    url: '/lmLossResponsibility/batchImport',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// LM损失定责-修改责任网点
export const lmLossResponsibilityUpdateResponsibleBranch = (data) => {
  return request({
    url: '/lmLossResponsibility/updateResponsibleOutlets',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// LM损失定责-下拉选项
export const lmLossResponsibilityGetDropdownOptions = () => {
  return request({
    url: '/lmLossResponsibility/getDropdownOptions',
    method: 'get',
    baseURL: baseURLAdmin
  });
};
// FM定责-时效延误-分页查询
export const fmLiabilityPage = (data) => {
  return request({
    url: '/report/fmLiability/getTimelinessDetails',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// FM定责-时效延误-汇总查询
export const getTimelinessTotal = (data) => {
  return request({
    url: '/report/fmLiability/getTimelinessTotal',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// FM定责-时效延误-汇总查询
export const timelinessDetailsExport = (data) => {
  return request({
    url: '/report/fmLiability/timelinessDetailsExport',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// FM定责-丢失-分页查询
export const getLostPackagePageApi = (data) => {
  return request({
    url: '/report/fmLiability/getLostPackageTrackingDetails',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// FM定责-丢失-汇总查询
export const getLostPackageTrackingTotal = (data) => {
  return request({
    url: '/report/fmLiability/getLostPackageTrackingTotal',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
export const getAllCottageList = () => {
  // return request.get('/site/getAllCottageList');
  return request({
    url: '/site/getAllCottageList',
    method: 'get',
    baseURL: baseURLAdmin
  });
};
// FM定责-丢失-导出
export const lostPackageTrackingDetailsExport = (data) => {
  return request({
    url: '/report/fmLiability/lostPackageTrackingDetailsExport',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 获取大区选项
export const lmLossResponsibilityGetRegionOptions = () => {
  return request({
    url: '/lmLossResponsibility/getRegionDropdownOptions',
    method: 'get',
    baseURL: baseURLAdmin
  });
};
// 获取网点所属州
export const lmLossResponsibilityGetStateOptions = (data) => {
  return request({
    url: '/area/getStateByRegion',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 网点所属转运中心
export const lmLossResponsibilityGetTransferCenterOptions = (data) => {
  return request({
    url: '/site/getDepartmentByState',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
